import { render, staticRenderFns } from "./BudgetBoxCreatePopup.vue?vue&type=template&id=573ed6ac&"
import script from "./BudgetBoxCreatePopup.vue?vue&type=script&lang=ts&"
export * from "./BudgetBoxCreatePopup.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetBoxCreatePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports